type FormatCurrencyOptions = {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export function formatCurrency(
  amount: number,
  currencyCode: string,
  options: FormatCurrencyOptions = {}
): string {
  const { locale = 'en-GB', minimumFractionDigits = 2, maximumFractionDigits = 2 } = options;
  const majorUnits = amount / 100;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(majorUnits);
  } catch {
    return `${currencyCode} ${majorUnits.toFixed(maximumFractionDigits)}`;
  }
}

export function formatCurrencyWhole(
  amount: number,
  currencyCode: string,
  locale = 'en-GB'
): string {
  return formatCurrency(amount, currencyCode, {
    locale,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
